<template>
  <div>
    <div>
      <radio-button
        v-model="typeSelector"
        value="path"
        id="type-path"
        name="type-selector"
        label="Type Path"
      ></radio-button>
      <radio-button
        v-model="typeSelector"
        value="type"
        id="type-specific"
        name="type-selector"
        label="Specific Type"
      ></radio-button>
    </div>
    <tree-drop-down v-model="selectedType" :items="treeItems" />
  </div>
</template>
<script>
import TreeDropDown from "@/components/common/forms/TreeDropDown.vue";

const walk = function (type, items) {
  const item = {
    id: type.systemName,
    label: type.name,
  };

  if (type.children && type.children.length > 0) {
    item.children = [];

    type.children.forEach((childType) => {
      walk(childType, item.children);
      0;
    });
  }

  items.push(item);
};

export default {
  components: { TreeDropDown },
  props: {
    availableTypes: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      selectedType: undefined,
      typeSelector: "path",
    };
  },
  computed: {
    typeItems: function () {
      return this.availableTypes.map((t) => ({
        label: t.name,
        value: t.systemName,
      }));
    },
    treeItems: function () {
      const items = [];

      this.availableTypes.forEach((type) => {
        walk(type, items);
      });

      return items;
    },
  },
  watch: {
    selectedType: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        const args = {
          selectedType: newValue,
          typeSelector: this.typeSelector,
        };

        this.logDebug("User has selected a type.", args);
        this.$emit("type-pick", args);
      }
    },
  },
  mounted: function () {
    this.selectedType = this.availableTypes[0].systemName;
  },
  emits: ["type-pick"],
};
</script>